import { Link, useParams } from 'react-router-dom';
import { Button, Spinner } from '@/components/ui';
import {
  useProjectView,
  useProjectParticipants,
} from '@/hooks/useProjectViews';
import { ProjectPaymentSummary } from './components/PaymentComponents';

export default function PaymentDetailPage() {
  const { id } = useParams<{ id: string }>();
  const query = useProjectView(id);
  const participants = useProjectParticipants(id ?? '');
  return (
    <div className="px-8 py-10 text-left lg:px-14">
      <nav className="mb-6 text-sm text-[#9B9B9B]" aria-label="Breadcrumb">
        <Link to="/payments" className="hover:text-[#F5F5F5]">
          Payments
        </Link>
        {query.data && (
          <span className="text-[#F5F5F5]"> / {query.data.title}</span>
        )}
      </nav>

      {query.isPending ? (
        <div
          role="status"
          className="flex min-h-[60vh] items-center justify-center"
        >
          <div className="flex flex-col items-center gap-4">
            <Spinner size="lg" />
            <p className="text-[#9B9B9B]">Loading project payments…</p>
          </div>
        </div>
      ) : query.isError ? (
        <div
          role="alert"
          className="mx-auto max-w-2xl rounded-xl border border-red-500/30 bg-[#231F1F] p-8 text-center"
        >
          <i
            className="ri-error-warning-line mb-3 block text-4xl text-red-400"
            aria-hidden="true"
          />
          <h2 className="mb-2 text-xl font-bold text-[#F5F5F5]">
            Failed to load payment details
          </h2>
          <p className="mb-4 text-[#9B9B9B]">{query.error.message}</p>
          <div className="flex justify-center gap-3">
            <Button onClick={() => void query.refetch()}>Retry</Button>
            <Link
              to="/payments"
              className="rounded-lg border border-[#3D3D3D] px-4 py-2 text-[#9B9B9B] transition-colors hover:border-[#555]"
            >
              Back to Payments
            </Link>
          </div>
        </div>
      ) : (
        <>
          <div className="mb-8">
            <div className="flex flex-wrap items-center gap-3">
              <h1 className="text-2xl font-bold text-[#F5F5F5]">
                {query.data.title}
              </h1>
              <Link
                className="text-xs text-[#36D399] hover:underline"
                to={'/projects/' + query.data.projectId}
              >
                View Project
              </Link>
            </div>
            {participants.data && (
              <p className="mt-1 text-sm text-[#9B9B9B]">
                Client:{' '}
                {participants.data.client.profiles?.client?.name ??
                  participants.data.client.displayName}
              </p>
            )}
          </div>
          <ProjectPaymentSummary project={query.data} />
          <Link
            className="inline-block text-sm text-[#36D399] hover:underline"
            to={'/payments/' + query.data.projectId + '/fund'}
          >
            Fund Project
          </Link>
        </>
      )}
    </div>
  );
}
